import React from "react";

function ITprojectContent() {
    return (
        <section className="skill-section bg-grey padding">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="video-wrap">
                            <img src="assets/img/post-13.jpg" alt="img" />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="section-heading mb-30">
                            <h2 className="text-anim" data-effect="fade-in-right" data-split="char" data-delay="0.3" data-duration={1}> IT Projects  </h2>
                            <p className="text-anim" data-effect="fade-in-bottom" data-ease="power4.out">
                            We provide <span style={{color : '#0A0909', fontWeight: '500'}}>customized IT project solutions</span> designed to enhance efficiency, reduce costs, and improve scalability for businesses.
                            </p>
                            <ul className="text-anim" data-effect="fade-in-bottom" data-ease="power4.out" style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                <li> Comprehensive Analysis: Understanding your business needs and providing strategic IT solutions. </li>
                                <li> Agile Development: Delivering projects faster and more efficiently using the latest methodologies. </li>
                                <li> Technical Expertise: Proficient in cloud technologies, software development, and IT infrastructure. </li>
                                <li> Ongoing Support: Ensuring long-term success with 24/7 maintenance and support. </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ITprojectContent;